import React, { FC, useContext } from 'react';
import { UserContext, UserContextType } from '../../Contexts/UserContext';
import { ContactCard32Filled } from '@fluentui/react-icons';
import { Avatar, Persona, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { formatDisplayName, generateInitials } from '../../Utils/personaUtils';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'center',
        height: '40px',
    },
    pic: {
        ...shorthands.borderRadius(tokens.borderRadiusCircular),
    },
    avatar: {
        '> span': {

            backgroundColor: tokens.colorNeutralForeground3,
            color: tokens.colorNeutralBackground6
        }
    }
});

// if the user has a photo on EntraID, show it, otherwise show the initials
// currently, no users have a photo on EntraID
export const UserPicture: FC = () => {
    const { userProfile } = useContext(UserContext) as UserContextType;
    const style = useStyles();
    const initials = generateInitials(userProfile?.name);
    
    return <div className={style.container}>
        {
            userProfile?.photo
                ? <img src={userProfile?.photo} className={style.pic} alt='profile' />
                : <Avatar
                    className={style.avatar}
                    name={userProfile?.name}
                    initials={initials}
                />
        }
    </div>;
};
